import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import { css, StyleSheet } from 'aphrodite';

import { backgroundGrey4 } from 'lib/css/colors';
import pointerOnHover from 'lib/css/pointerOnHover';

import { getAge } from 'lib/utils/dateUtils';
import {
  SupportTicketOriginLabels,
  SupportTicketStatusLabels,
  SupportTicketEntityType,
  SupportTicketEntityTypeLabels,
} from 'lib/enums/SupportTicketEnums';
function SupportTicketsTableRow({ ticket, onClick }) {
  return (
    <>
      <tr onClick={onClick} className={pointerOnHover}>
        <td className={css(styles.idColumn)}>{<strong>FSA - {ticket.id} </strong>}</td>
        <td style={{ position: 'relative' }}>
          <span>{ticket.task}</span>
          {ticket.comments?.length > 0 && (
            <span
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: backgroundGrey4,
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
              }}
            >
              <FontAwesomeIcon
                icon={faComments}
                style={{
                  color: '#666',
                }}
              />
              <span style={{ fontSize: '1.1em' }}>{ticket.comments.length}</span>
            </span>
          )}
        </td>
        <td>{SupportTicketOriginLabels[ticket.origin]}</td>
        <td>{SupportTicketEntityTypeLabels[ticket.entity_type]}</td>
        <td>
          {(() => {
            switch (ticket.entity_type) {
              case SupportTicketEntityType.DISTRIBUTOR:
                return ticket.global_vendor?.name || ticket.meta_data.global_vendor?.name || '-';
              case SupportTicketEntityType.MANUFACTURER:
                return (
                  ticket.global_manufacturer?.name ||
                  ticket.meta_data.global_manufacturer?.name ||
                  '-'
                );
              case SupportTicketEntityType.BRAND:
                return ticket.brand?.name || ticket.meta_data.brand?.name || '-';
              default:
                return '-';
            }
          })()}
        </td>
        <td>{SupportTicketStatusLabels[ticket.status]}</td>
        <td>
          {ticket.assigned_to
            ? ticket.assigned_to.name
            : ticket.meta_data?.assigned_to?.name || '-'}
        </td>
        <td>{getAge(ticket.date_created)}</td>
      </tr>
    </>
  );
}

const styles = StyleSheet.create({
  idColumn: {
    minWidth: '100px',
  },
});

SupportTicketsTableRow.propTypes = {
  ticket: PropTypes.object,
  onClick: PropTypes.func,
};

export default SupportTicketsTableRow;
